<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">急救服务</h3>
            <p class="depth bullet03">对急救 (或分娩) 患者不分公共假日, 全年无休, 24小时提供医疗服务.</p>
            <p class="depth bullet03">为了确保我们准备好全天候为急诊患者服务, 我们配备了急救医疗设备, 并配备了专业人员. 我们总是尽全力提供及时的急救服务.</p>
            <p class="depth bullet03">急诊患者将直接在我们的急诊室接受医疗护理, 无论医疗服务提供系统 (与在初级还是二级医疗机构就诊无关) 或其所在地区如何.</p>
            <p class="depth bullet03">急救中心的无线通信网络, 急救医疗设备, 救护车等全年无休, 24小时待命, 以形成急救医疗网络, 尽可能减少夜间和节假日的服务缺口.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">急诊服务登记</h3>
            <p class="depth">到达急诊室后，患者在重症分离室接受预诊，并在急诊室内的急诊行政登记、缴纳窗口提交诊疗申请书和健康保险证(医疗保健证)、身份证.</p>
            <p class="depth">从行政窗口领取急诊患者的标牌与手环后，交给护士办公室进行确认.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">急诊服务</h3>
            <p class="depth">关于住院及出院问题，由急诊室医生进行诊疗后在决定.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">支付急诊服务费用</h3>
            <p class="depth">
                急诊患者的诊疗费在确定出院后进行缴纳. <br>
                进行特殊检查（磁共振成像、CT扫描与超声波检查）时，须提前支付.<br>
                无参加健康保险或医疗保险的患者应全额缴纳.<br>
                可以用信用卡支付.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">办理出院手续和住院</h3>
            <div class="table">
                <table>
                    <colgroup>
                        <col style="width: 50%;">
                        <col style="width: 50%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>办理出院手续后</th>
                            <th>住院治疗</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                请将诊疗费用单据交给护士确认后领取药物，对下一步的治疗计划与出院后注意事项进行商谈后回家.
                            </td>
                            <td>
                                将确定住院时，按照主管护士的住院手续指引，请到急诊行政登记处办理住院手续.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>